import devHelper from '../../util/devHelper'
import dbHelper from '../../util/db'
import debugHelper from '../../util/debug'
import msgbus from '../../msgBus'
import i18n from '../../lang/index'


var versionCheckHelper = {

  // 获取APP显示版本信息
  funcGetAppDispVersion() {
    console.log('调试代码')
    let localVersion = msgbus.vm.getLocalVersion()
    window.cordova.getAppVersion.getVersionNumber(function (version) {
      dbHelper.set('AppVersion', version)
    })
    if (msgbus.vm.getPlatform() == 'iOS') {
      window.cordova.getAppVersion.getVersionNumber(function (version) {
        let appDispVersion = version + localVersion.substring(localVersion.lastIndexOf('.'), localVersion.length)
        msgbus.vm.setAppDispVersion({ value: appDispVersion })
      })
    } else if (msgbus.vm.getPlatform() == 'Android') {
      window.cordova.getAppVersion.getVersionNumber(function (version) {
        let appDispVersion = version + localVersion.substring(localVersion.lastIndexOf('.'), localVersion.length)
        msgbus.vm.setAppDispVersion({ value: appDispVersion })
      })
    } else {
      let appDispVersion = msgbus.vm.getLocalVersion()
      msgbus.vm.setAppDispVersion({ value: appDispVersion })
    }
  },

  // 获取APP服务端版本信息
  funcGetAppServerVersion() {
    console.log('调试代码')
    if (msgbus.vm.getPlatform() == 'Android') {
      msgbus.vm.checkAndroidAppVersion({
        vm: msgbus.vm,
        authorization: {
          Authorization: 'Bearer ' + msgbus.vm.getAccountToken()
        }
      }).then(() => {
        var appServerVersion = msgbus.vm.getAppServerVersion()
        // alert('appServerVersion' + appServerVersion)
        // 清除apk之前版本的缓存信息
        versionCheckHelper.funcClearApkCache('ids' + appServerVersion + '.apk')
      })
    } else {
      msgbus.vm.checkIOSAppVersion({
        vm: msgbus.vm,
        authorization: {
          Authorization: 'Bearer ' + msgbus.vm.getAccountToken()
        }
      }).then(() => {
        var appServerVersion = msgbus.vm.getAppServerVersion()
        // alert('appServerVersion' + appServerVersion)
      })
    }
  },

  // 检查版本更新（用户登录后，自动检查版本，若有新版本，则提示需更新）
  funcCheckAPKUpdate() {
    console.log('代码调试')
    if (msgbus.vm.getPlatform() == 'Android') {
      msgbus.vm.checkAndroidAppVersion({
        vm: msgbus.vm,
        authorization: {
          Authorization: 'Bearer ' + msgbus.vm.getAccountToken()
        }
      }).then(() => {
        if (dbHelper.get('downloadAPKFinish') && dbHelper.get('downloadAPKFinish') != 'true') { // 已经开始下载但未完成
          msgbus.vm.setIsUpdateVersion({ value: false })
          //如果存在正在下载或者没下完被终止的情况，不用弹出提示
          versionCheckHelper.funcDownloadVersion()
        } else { // 没有开始下载或已完成
          var appServerVersion = msgbus.vm.getAppServerVersion()
          // alert('appServerVersion' + appServerVersion)
          window.cordova.getAppVersion.getVersionNumber(function (version) {
            // alert('AppVersion' + version)
            dbHelper.set('AppVersion', version)
            // 版本比较
            if (versionCheckHelper.compare(appServerVersion, version)) {
              dbHelper.set('AppVersion', version)
              // alert('AppVersion' + version)
              // 弹出交互框,由用户决定是否下载更新文档
              msgbus.vm.setIsUpdateVersion({ value: true })
            }
          }).catch((err) => {
            alert(err)
          })
        }
      })
    } else {
      msgbus.vm.checkIOSAppVersion({
        vm: msgbus.vm,
        authorization: {
          Authorization: 'Bearer ' + msgbus.vm.getAccountToken()
        }
      }).then(() => {
        var appServerVersion = msgbus.vm.getAppServerVersion()
        window.cordova.getAppVersion.getVersionNumber(function (version) {
          dbHelper.set('AppVersion', version)
          if (versionCheckHelper.compare(appServerVersion, version)) {
            msgbus.vm.setSnackBar({
              value: {
                color: 'error',
                text: i18n.t('app需大版本更新，请立即更新到最新版本'),
                visible: true
              }
            })
            msgbus.vm.setIsUpdateVersion({ value: true })
          }
        })
      })
    }
  },
  // 检查版本更新（手动点击我的页面-版本更新检查，若有新版本，则提示需更新）
  funcClickCheckAPKUpdate: function () {
    if (msgbus.vm.getPlatform() == 'Android') {
      msgbus.vm.checkAndroidAppVersion({
        vm: msgbus.vm,
        authorization: {
          Authorization: 'Bearer ' + msgbus.vm.getAccountToken()
        }
      }).then(
        () => {
          window.cordova.getAppVersion.getVersionNumber(function (version) {
            debugHelper.log('checkSuccess')
            var curVer = msgbus.vm.getAppServerVersion()

            if (!versionCheckHelper.compare(curVer, version)) {
              msgbus.vm.setSnackBar({
                value: {
                  color: 'success',
                  text: i18n.t('当前已是最新版本'),
                  visible: true
                }
              })
            } else {
              if (dbHelper.get('downloadAPKFinish') && dbHelper.get('downloadAPKFinish') != 'true') { // 已经开始下载但未完成
                msgbus.vm.setSnackBar({
                  value: {
                    color: 'info',
                    text: i18n.t('新版本正在下载，请稍后点击'),
                    visible: true
                  }
                })
              } else { // 没有开始下载或已完成
                msgbus.vm.setIsUpdateVersion({ value: true })
              }
            }
          })
        },
        () => {
          debugHelper.log('checkFailed')
        }
      )
    } else if (msgbus.vm.getPlatform() == 'iOS') {
      msgbus.vm.checkIOSAppVersion({
        vm: msgbus.vm,
        authorization: {
          Authorization: 'Bearer ' + msgbus.vm.getAccountToken()
        }
      }).then(() => {
        var appServerVersion = msgbus.vm.getAppServerVersion()
        window.cordova.getAppVersion.getVersionNumber(function (version) {
          dbHelper.set('AppVersion', version)
          if (versionCheckHelper.compare(appServerVersion, version)) {
            msgbus.vm.setSnackBar({
              value: {
                color: 'error',
                text: i18n.t('app需大版本更新，请立即更新到最新版本'),
                visible: true
              }
            })
            msgbus.vm.setIsUpdateVersion({ value: true })
          } else {
            msgbus.vm.setSnackBar({
              value: {
                color: 'success',
                text: i18n.t('当前已是最新版本'),
                visible: true
              }
            })
          }
        })
      })
    }
  },
  // 版本更新
  funcDownloadVersion() {
    if (msgbus.vm.getPlatform() == 'iOS') {
      window.cordova.InAppBrowser.open('itms-apps://apps.apple.com/cn/app/%E6%95%B0%E7%BB%9C%E5%AF%86%E7%9B%BE/id1538927281', '_system', 'location=no,hidden = yes')
    } else if (msgbus.vm.getPlatform() == 'Android' && msgbus.vm.getAppDownloadUrl()) {
      versionCheckHelper.autoDownloadAPK(true)
    }
  },
  // 下载APK
  autoDownloadAPK(auto) {
    if (auto) {
      if (devHelper.isDevMode()) {
        alert(`externalDataDirectory: ${window.cordova.file.externalDataDirectory}`)
      }
      window.resolveLocalFileSystemURL(
        window.cordova.file.externalDataDirectory,
        function (fs) {
          if (devHelper.isDevMode()) {
            alert(`fs: ${JSON.stringify(fs)}`)
          }
          fs.getFile(
            'ids' + msgbus.vm.getAppServerVersion() + '.apk', // 创建的文件名
            { create: true, exclusive: true },
            // create：创建新文件，exclusive:文件已存在时抛出异常
            function (fileEntry) {
              if (devHelper.isDevMode()) {
                alert(`fileEntry1: ${JSON.stringify(fileEntry)}`)
              }
              // 创建成功回调下载方法写入文件
              versionCheckHelper.downloadAPK(fileEntry, true)
            },
            function (err) {
              if (devHelper.isDevMode()) {
                alert(`err1: ${JSON.stringify(err)}`)
              }
              fs.getFile(
                'ids' + msgbus.vm.getAppServerVersion() + '.apk',
                { create: false },
                function (fileEntry) {
                  if (devHelper.isDevMode()) {
                    alert(`fileEntry2: ${JSON.stringify(fileEntry)}`)
                  }
                  // 成功读取文件后调用cordova-plugin-file-opener2插件打开文件
                  if (dbHelper.get('downloadAPKFinish') && dbHelper.get('downloadAPKFinish') != 'true') { // 已经开始下载但未完成
                    if (dbHelper.get('launchTimes') && dbHelper.get('launchTimes') == '1') { //是第一次启动，代表之前是强制结束没有下载完成，删除apk并重新下载
                      fileEntry.remove(function () {
                        versionCheckHelper.autoDownloadAPK(true)
                      })
                    } else { //不是第一次启动，代表切来切去，提示正在更新
                      msgbus.vm.setSnackBar({
                        value: {
                          color: 'info',
                          text: i18n.t('新版本正在下载，请稍后点击'),
                          visible: true,
                        },
                      })
                    }
                  } else { // 没有开始下载或已完成
                    versionCheckHelper.previewAPK(fileEntry)
                  }
                },
                function (err) {
                  if (devHelper.isDevMode()) {
                    alert(`err2: ${JSON.stringify(err)}`)
                  }
                }
              )
            }
          )
        },
        function (error) {
          if (devHelper.isDevMode()) {
            alert(`error: ${JSON.stringify(error)}`)
          }
        }
      )
    } else {
      window.resolveLocalFileSystemURL(
        window.cordova.file.externalDataDirectory,
        function (fs) {
          fs.getFile(
            'ids' + msgbus.vm.getAppServerVersion() + '.apk', // 创建的文件名
            { create: true, exclusive: true },
            // create：创建新文件，exclusive:文件已存在时抛出异常
            function (fileEntry) {
              // 创建成功回调下载方法写入文件
              versionCheckHelper.downloadAPK(fileEntry, false)
            },
            function (err) {
              fs.getFile(
                'ids' + msgbus.vm.getAppServerVersion() + '.apk',
                { create: false },
                function (fileEntry) {
                  // 成功读取文件后调用cordova-plugin-file-opener2插件打开文件
                  if (dbHelper.get('downloadAPKFinish') && dbHelper.get('downloadAPKFinish') != 'true') { // 已经开始下载但未完成
                    fileEntry.remove(function () {
                      versionCheckHelper.autoDownloadAPK(false)
                    })
                  } else { // 没有开始下载或已完成
                    msgbus.vm.setIsUpdateVersion({ value: true })
                  }
                },
                function (err) {
                }
              )
            }
          )
        },
        function (error) {
        }
      )
    }
  },
  downloadAPK(fileEntry, auto) {
    let nativeURL = fileEntry.nativeURL || fileEntry.toURL()
    if (devHelper.isDevMode()) {
      alert(`downloadAPK: ${JSON.stringify(fileEntry)}`)
      alert(`getAppDownloadUrl(): ${msgbus.vm.getAppDownloadUrl()}`)
      alert(`toURL(): ${fileEntry.toURL()}`)
      alert(`nativeURL: ${nativeURL}`)
    }
    var fileTransfer = new window.FileTransfer()
    msgbus.vm.setUpdateProgressPre({ value: 0 })
    fileTransfer.onprogress = function (e) {
      if (e.lengthComputable) {
        let progress = e.loaded / e.total
        if (progress < 1) {
          dbHelper.set('downloadAPKFinish', false)
          msgbus.vm.setUpdateProgressPre({ value: progress * 100 })
        } else {
          dbHelper.set('downloadAPKFinish', true)
          msgbus.vm.setUpdateProgressPre({ value: 0 })
        }
      }
    }
    // 使用fileTransfer.download开始下载
    fileTransfer.download(
      encodeURI(msgbus.vm.getAppDownloadUrl().toString()), //uri网络下载路径
      nativeURL, //文件本地存储路径
      function (entry) {
        if (devHelper.isDevMode()) {
          alert(`entry: ${JSON.stringify(entry)}`)
        }
        // 下载完成执行本地预览
        entry.file((data) => {
          if (devHelper.isDevMode()) {
            alert(`data: ${JSON.stringify(data)}`)
          }
          if (auto) {
            versionCheckHelper.previewAPK(entry)
          } else {// 弹出交互框
            msgbus.vm.setIsUpdateVersion({ value: true })
          }
        })
      },
      function (error) {
        if (devHelper.isDevMode()) {
          alert(`error: ${JSON.stringify(error)}`)
        }
      }
    )
  },
  previewAPK(fileEntry) {
    let cdvfileURL = fileEntry
      .toInternalURL()
      .replace('https://', 'cdvfile://')
      .replace('file:///__cdvfile_files-external__', 'cdvfile://localhost/__cdvfile_files-external__')
    if (devHelper.isDevMode()) {
      alert(`previewAPK: ${JSON.stringify(fileEntry)}`)
      alert(`toInternalURL(): ${fileEntry.toInternalURL()}`)
      alert(`cdvfileURL: ${cdvfileURL}`)
    }
    // 调用cordova-plugin-file-opener2插件实现用第三方app打开文件
    window.cordova.plugins.fileOpener2.showOpenWithDialog(
      // 此处必须填写cdvfile://地址，不然android7.0+会报文件权限错误
      cdvfileURL, //文件本地地址转cdvfile://地址
      'application/vnd.android.package-archive',
      {
        success: function (data) {
          if (devHelper.isDevMode()) {
            alert(`success: ${JSON.stringify(data)}`)
          }
        },
        error: function (error) {
          if (devHelper.isDevMode()) {
            alert(`error: ${JSON.stringify(error)}`)
          }
        }
      }
    )
  },
  // 清理APK缓存
  // serverAPKName不在清理范围的apk名称
  funcClearApkCache(serverAPKName) {
    if (msgbus.vm.getPlatform() == 'Android') {
      window.resolveLocalFileSystemURL(
        window.cordova.file.externalDataDirectory,
        function (entry) {
          var dirReader = entry.createReader()
          //返回目录下文件和目录信息
          dirReader.readEntries(function (results) {
            if (devHelper.isDevMode()) {
              alert('funcClearApkCache: ' + JSON.stringify(results))
              alert('serverAPKName: ' + serverAPKName)
            }
            serverAPKName = serverAPKName.toLowerCase()
            for (let i = 0; i < results.length; i++) {
              let name = results[i].name.toLowerCase()
              if (results[i].isFile && name.lastIndexOf('apk') !== -1 && (serverAPKName == '' || name != serverAPKName)) {
                window.resolveLocalFileSystemURL(results[i].toURL(), function (fs) {
                  if (devHelper.isDevMode()) {
                    alert('(entries[i]' + JSON.stringify(results[i]))
                  }
                  fs.remove()
                })
              }
            }
          })
        }
      )
    }
  },
  // 比较版本号
  compare(curV, reqV) {
    if (curV && reqV) {
      //将两个版本号拆成数字
      var arr1 = curV.split('.'),
        arr2 = reqV.split('.')
      var minLength = Math.min(arr1.length, arr2.length),
        position = 0,
        diff = 0,
        limit = 0
      //依次比较版本号每一位大小，当对比得出结果后跳出循环（后文有简单介绍）
      while (
        position < minLength &&
        (diff = parseInt(arr1[position]) - parseInt(arr2[position])) == 0 &&
        limit < 3
      ) {
        position++, limit++
      }
      diff = diff != 0 ? diff : 0
      //若curV大于reqV，则返回true
      return diff > 0
    } else {
      //输入为空
      console.log('版本号不能为空')
      return false
    }
  },
  //--------------------------------------------------------------------------------------

  // 接口测试
  funcCheckAPKUpdateTest() {
    msgbus.vm.checkAndroidAppVersion({
      vm: msgbus.vm,
      authorization: {
        Authorization: 'Bearer ' + msgbus.vm.getAccountToken()
      }
    }).then(() => {
      var appServerVersion = msgbus.vm.getAppServerVersion()
      alert('appServerVersion' + appServerVersion)
    })
  }
}
export default versionCheckHelper
